"use client";

import { Button } from "@/components/ui/button";
import { Action, ControlType } from "@/context/AnalyticsProvider";
import { useHomepageAnalytics } from "@/context/AnalyticsProvider/homepage";
import { Filter } from "lucide-react";
import { useEffect, useRef } from "react";
import { QuestFilterPanel } from "./QuestFilterPanel";
import { useQuestFilter } from "./QuestFilterProvider";
import { QuestFilterResults } from "./QuestFilterResults";

export function QuestFilterLayout() {
  const { isMobile, setIsMobile, totalQuestCount } = useQuestFilter();
  const { track } = useHomepageAnalytics();
  const hasViewedRef = useRef(false);

  useEffect(() => {
    if (hasViewedRef.current) return;
    hasViewedRef.current = true;
    track({
      action: Action.VIEWED,
      extras: {
        id: "quest-finder",
      },
    });
  }, [track]);

  // Prevent body scroll when mobile filter is open
  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobile]);

  return (
    <div className="relative z-10 py-8">
      <div className="w-full h-px bg-white/90 mb-6" />

      {/* Desktop Layout - Two Columns */}
      <div className="hidden lg:flex gap-8 items-start">
        <div className="w-[360px] flex-shrink-0 sticky top-4">
          <QuestFilterPanel />
        </div>

        <div className="flex-1">
          <QuestFilterResults />
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="lg:hidden">
        <div className="flex items-start justify-between gap-4 px-4 mb-6">
          <div>
            <h1 className="text-2xl font-bold text-white">Quests</h1>
            <p className="text-sm text-white/60">{totalQuestCount} quests</p>
          </div>
          <Button
            onClick={() => {
              setIsMobile(true);
              track({
                action: Action.PRESSED,
                extras: {
                  id: "quest-finder",
                  control: "OpenFilterMobile",
                  controlType: ControlType.BUTTON,
                },
              });
            }}
            variant="outline"
            size="default"
            className="bg-white text-black hover:bg-white/90 flex-shrink-0"
          >
            <Filter className="w-4 h-4 mr-2" />
            Filters
          </Button>
        </div>

        <div className="px-4">
          <QuestFilterResults />
        </div>

        {/* Full Screen Filter Modal */}
        {isMobile && (
          <div className="fixed inset-0 z-50 bg-neutral-950 overflow-y-auto">
            <div className="px-4 mb-16">
              <QuestFilterPanel
                onClose={() => {
                  setIsMobile(false);
                  track({
                    action: Action.PRESSED,
                    extras: {
                      id: "quest-finder",
                      control: "CloseFilterMobile",
                      controlType: ControlType.BUTTON,
                    },
                  });
                }}
                showCloseButton
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
